import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'Pods/Shared/I18n'

import WithDraggableList from 'Pods/Shared/Hocs/WithDraggableList'

class UserNavBarContent extends React.Component {
  tabClassName(tabSlug) {
    return this.props.activeTab === tabSlug ? 'tab is-active' : 'tab'
  }

  render() {
    const listings = i18n.t('profilePage.listings', { ns: 'rails', lng: this.props.locale } )
    const reviews = i18n.t('profilePage.reviews', { ns: 'rails', lng: this.props.locale } )
    const tutorials = i18n.t('profilePage.tutorials', { ns: 'rails', lng: this.props.locale } )

    const menuCategories = [{
      id: 'listings',
      count: this.props.counts.modelCount,
      label: listings,
    }, {
      id: 'reviews',
      count: this.props.counts.ratings.model.count + this.props.counts.ratings.project.count,
      label: reviews,
    }, {
      id: 'tutorials',
      count: this.props.counts.tutorialCount,
      label: tutorials,
    }]

    return (
      <ul className="nav-tabs nav-tabs--small user-navbar__tabs">
        {menuCategories.map(menuItem => (
          <li className={this.tabClassName(menuItem.id)} key={menuItem.id}>
            <a onClick={() => this.props.onClick((menuItem.id))}>
              {menuItem.label} <span className="user-tag__counter">{menuItem.count}</span>
            </a>
          </li>
        ))}
      </ul>
    )
  }
}

UserNavBarContent.propTypes = {
  activeTab: PropTypes.string.isRequired,
  counts: PropTypes.shape({
    modelCount: PropTypes.number.isRequired,
    galleryCount: PropTypes.number.isRequired,
    tutorialCount: PropTypes.number.isRequired,
  }).isRequired,
  categories: PropTypes.object,
}

export default WithDraggableList(UserNavBarContent)
